// extracted by mini-css-extract-plugin
export default {"wrapper":"ResetPassword_wrapper__stjRD","completedMessageWrapper":"ResetPassword_completedMessageWrapper__hQG7r","icon":"ResetPassword_icon__QhFS1"};